import { styled } from 'styled-components'

import {
	BoutonConseillersEntreprises,
	type ConseillersEntreprisesVariant,
} from '../ConseillersEntreprises/BoutonConseillersEntreprises'
import { BoutonDétail } from './Boutons/BoutonDétail'
import { BoutonPartage } from './Boutons/BoutonPartage'

type Props = {
	conseillersEntreprisesVariant?: ConseillersEntreprisesVariant
	avecBoutonDétails: boolean
	avecBoutonPartage?: boolean
}

export const Actions = ({
	conseillersEntreprisesVariant,
	avecBoutonDétails,
	avecBoutonPartage = true,
}: Props) => (
	<Container>
		<LeftColumn>
			{avecBoutonPartage && <BoutonPartage />}
			{conseillersEntreprisesVariant && (
				<BoutonConseillersEntreprises variant={conseillersEntreprisesVariant} />
			)}
		</LeftColumn>
		{avecBoutonDétails && (
			<RightColumn>
				<BoutonDétail />
			</RightColumn>
		)}
	</Container>
)

const Container = styled.div`
	display: flex;
	flex-direction: column;
	flex-wrap: wrap;
	align-items: center;
	gap: ${({ theme }) => theme.spacings.lg};
	@media (min-width: ${({ theme }) => theme.breakpointsWidth.lg}) {
		margin: ${({ theme }) => theme.spacings.xs} 0;
		flex-direction: row;
		align-items: start;
	}
`

const LeftColumn = styled.div`
	order: 2;
	display: flex;
	flex-direction: column;
	gap: ${({ theme }) => theme.spacings.lg};
	@media (min-width: ${({ theme }) => theme.breakpointsWidth.md}) {
		flex-direction: row;
	}
	@media (min-width: ${({ theme }) => theme.breakpointsWidth.lg}) {
		width: calc(50% - ${({ theme }) => theme.spacings.lg});
		flex-direction: column;
	}
	@media (min-width: ${({ theme }) => theme.breakpointsWidth.xl}) {
		flex-direction: row;
	}
`
const RightColumn = styled.div`
	display: flex;
	justify-content: center;
	align-items: start;
	@media (min-width: ${({ theme }) => theme.breakpointsWidth.lg}) {
		order: 2;
		width: 50%;
	}
`
